'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _validation = require('utils/validation');

var validation = _interopRequireWildcard(_validation);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

var required = validation.required,
    email = validation.email,
    minLength = validation.minLength; //This module is required for the same test fields in the application

exports.default = {
  email: [required, email],
  emailNotRequired: [email],
  password: [required, minLength(6)],
  name: [required, minLength(2)],
  lastName: [required, minLength(2)],
  company: [required, minLength(2)],
  message: [required, minLength(6)],
  field: [required]
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/helpers/formValidation.js
// module id = 263
// module chunks = 1